module.exports = __webpack_public_path__ + "img/BoxTruck.4203611f.png";